import {styled} from '@mui/material';
import React from 'react';
import {useContactTypes} from '../hooks';

const Container = styled('div')(() => ({
  display: 'flex',
  margin: 0,
  padding: 0,
}));

const Type = styled('div')(({theme}) => ({
  background: 'var(--type-colour)',
  borderRadius: 4,
  color: theme.palette.common.white,
  fontWeight: '700',
  marginRight: theme.spacing(1),
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,

  '&:last-of-type': {
    marginRight: 0,
  },
}));

const ContactTypes = ({contact}) => {
  const types = useContactTypes();
  return (
    <Container>
      {['customer', 'supplier', 'prospect', 'transporter']
        .filter(t => contact[`is_${t}`])
        .map(t => types.find(type => type.key === `${t}s`))
        .filter(t => t)
        .map(({singular, colour}, index) => (
          <Type key={index} style={{'--type-colour': colour}}>{singular}</Type>
        ))}
    </Container>
  );
}

export default ContactTypes;
